<script>
// 新建企业资质
import DatePickr from "@/views/widgets/date-pickr";
import UploadWithPreview from "@/views/widgets/upload-files/upload-with-preview";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {alertError, successMsg} from "@/helpers/swal";
import {addCompanyQualification,patchCompanyQualification} from "@/service";
import _ from "lodash";
export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    companyId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      showModal: false,
      title: this.$t('page.create'),
      form: {},
      attachment: [], // 文件对象列表
    }
  },
  validations: {
    form: {
      name: { required },
      issued: { required },
      begin_at: { required },
      end_at: { required },
      attachment: { required },
    }
  },
  methods: {
    open(item) {
      this.formInit(_.cloneDeep(item))
      this.showModal = true

      this.v$.form.$reset()
    },
    formInit(item) {
      this.form = {
        name: null,
        issued: null,
        begin_at: null,
        end_at: null,
        attachment: [],
        company: this.companyId,
      }
      this.title = this.$t('page.create')
      this.attachment = []
      if (item) {
        this.title = this.$t('page.modify')
        this.form['id'] = item.id
        for (let p in this.form) {
          if (p == 'attachment') {
            this.form['attachment'] = _.map(item['attachment'], 'id')
            this.attachment = item['attachment']
          } else {
            this.form[p] = item[p]
          }
        }
      }
    },
    pictureChange(ids) {
      this.form.attachment = ids
    },
    async save() {
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      if (!result) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      let saveFun = null
      let msg = ''
      if (this.form.id) {
        // 编辑
        saveFun = patchCompanyQualification
        msg = this.$t('base.modified_successfully')
      } else {
        // 新增
        saveFun = addCompanyQualification
        msg = this.$t('base.add_success')
      }
      saveFun(this.form).then((res) => {
        if (![200, 201].includes(res.meta.code)) {
          alertError(this.$t('base.prompt'), res.meta.message)
          return
        }
        successMsg(msg)
        this.showModal = false
        this.$emit('refresh')
      }).catch((err) => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('page.errorOccurred'))
      })
    },
  },
  components: {
    DatePickr,
    UploadWithPreview,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
  >
    <div class="modal-body border-top">
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('serviceCompany.certificate_name')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
        <input type="text" class="form-control" :class="v$.form.name.$errors.length ? 'is-invalid' : ''" :placeholder="this.$t('serviceCompany.certificate_name')" v-model="form.name"/>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('serviceCompany.awarding_body')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
        <input type="text" class="form-control" :class="v$.form.issued.$errors.length ? 'is-invalid' : ''" :placeholder="this.$t('serviceCompany.awarding_body')" v-model="form.issued" required/>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('serviceCompany.indate')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
        <div class="d-flex justify-content-between align-items-center">
          <DatePickr :placeholder="this.$t('serviceCompany.begin_date')" :value="form.begin_at" v-model="form.begin_at" class="flex-grow-1" :is-invalid="Boolean(v$.form.begin_at.$errors.length)" />
          <span style="width: 50px;text-align: center;">-</span>
          <DatePickr :placeholder="this.$t('serviceCompany.end_date')" :value="form.end_at" v-model="form.end_at" class="flex-grow-1" :is-invalid="Boolean(v$.form.end_at.$errors.length)" />
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('serviceCompany.certificate_photo')}}<span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></label>
        <upload-with-preview
            :value="attachment"
            input-id="uploadCertificate"
            :multiple="true"
            preview-type="thumb"
            filename-prefix="sc"
            @changed="pictureChange"
        ></upload-with-preview>
      </div>
    </div>

    <div class="modal-footer v-modal-footer">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="save">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>
